var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.infoWindow.open
    ? _c("div", { staticClass: "info-window" }, [
        _c("h4", [_vm._v(_vm._s(_vm.infoWindow.title))]),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _c("p", { staticClass: "flex" }, [
            _c("img", {
              staticClass: "map",
              attrs: { src: "/images/location-green.svg", alt: "" }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.infoWindow.address))])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "flex" }, [
            _c("img", {
              staticClass: "phone",
              attrs: { src: "/images/phone-green.svg", alt: "" }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.infoWindow.phone))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "detail-buttons" }, [
          _c(
            "a",
            { staticClass: "map details", attrs: { href: _vm.infoWindow.url } },
            [_vm._v("\n      View Details\n    ")]
          ),
          _vm._v(" "),
          _c("a", [_vm._v("\n        Book Now\n    ")])
        ]),
        _vm._v(" "),
        _vm.infoFeaturesShow
          ? _c(
              "ul",
              { staticClass: "list" },
              _vm._l(_vm.infoWindow.features, function(feature, index) {
                return _c("li", { key: index }, [
                  _vm._v("\n      " + _vm._s(feature) + "\n    ")
                ])
              }),
              0
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1413cbb7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1413cbb7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/locations/InfoWindow2.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1413cbb7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/locations/InfoWindow2.vue
// module chunks = 0